const expandButton = document.querySelector('.loopServicesTerms__expand');
const TOGGLED_CLASS = 'loopServicesTerms__list--expanded';
if (expandButton) {
    expandButton.addEventListener('click', function () {
        const container = document.querySelector('.loopServicesTerms__list');
        if (container.classList.contains(TOGGLED_CLASS)) {
            container.classList.remove(TOGGLED_CLASS);
        } else {
            this.style.display = 'none';
            container.classList.add(TOGGLED_CLASS);
        }
    });
}
